import { useEffect } from 'react';
import { SITE_NAME, FAVICON_URL, toAbsoluteUrl } from './seo';

export interface ArticleSchemaInput {
  title: string;
  description: string;
  image: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
}

export function buildOrganization() {
  return {
    '@type': 'Organization',
    name: SITE_NAME,
    url: toAbsoluteUrl('/'),
    logo: { '@type': 'ImageObject', url: FAVICON_URL },
  };
}

export function buildWebSiteSchema(description: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: toAbsoluteUrl('/'),
    description,
    publisher: buildOrganization(),
  };
}

export function buildArticleSchema(data: ArticleSchemaInput) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: data.title,
    description: data.description,
    image: data.image,
    author: { '@type': 'Organization', name: 'CSSBuy Research Team' },
    publisher: buildOrganization(),
    datePublished: data.datePublished || '2026-08-30',
    dateModified: data.dateModified || '2026-08-30',
    mainEntityOfPage: { '@type': 'WebPage', '@id': toAbsoluteUrl(data.url) },
  };
}

export function setJsonLd(data: object | object[]): void {
  const id = 'seo-jsonld';
  let script = document.getElementById(id) as HTMLScriptElement | null;
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export function clearJsonLd(): void {
  const script = document.getElementById('seo-jsonld');
  if (script) script.remove();
}

export function useJsonLd(data: object | object[] | null): void {
  useEffect(() => {
    if (data) {
      setJsonLd(data);
    } else {
      clearJsonLd();
    }
    return () => clearJsonLd();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);
}